import React from 'react';
import Markdown from 'markdown-to-jsx';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import classnames from 'classnames';

const { node, string } = proptypes;

const MessageBubble = ({ type, children }) => {
  const isBot = type === 'bot';

  // eslint-disable-next-line tailwindcss/no-arbitrary-value
  const spacerClasses = classnames(
    'sui-flex sui-mb-2 last:sui-mb-0 sui-max-w-[75%] sui-grow sui-shrink-1 sui-p-3 sui-rounded-lg',
    {
      'sui-bg-inverse sui-self-end': !isBot,
      'sui-bg-subtle': isBot,
    },
  );

  return (
    <div
      className={spacerClasses}
      role="article"
      aria-label={isBot ? 'Bot Message' : 'User Message'}
    >
      <Typography
        component="div"
        variant="body-base"
        color={isBot ? 'primary' : 'inverse'}
        height="normal"
        id="maa-message"
      >
        <Markdown
          options={{
            overrides: {
              // eslint-disable-next-line id-length
              a: {
                component: 'a',
                props: {
                  className: 'sui-underline',
                  target: '_parent'
                },
              },
              ol: {
                props: { className: 'sui-list-decimal' }
              },
              ul: {
                props: { className: 'sui-list-disc' }
              },
              li: {
                props: {
                  className: 'sui-mb-1 sui-ml-5 sui-list-outside'
                }
              },
            },
          }}
        >
          {children.replaceAll(/\n\n/g, '\n\n &nbsp; \n\n')}
        </Markdown>
      </Typography>
    </div>
  );
};

MessageBubble.propTypes = {
  children: node.isRequired,
  type: string.isRequired
};

export { MessageBubble };
